import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {LocalStorageService} from 'angular-2-local-storage';
import {Router} from '@angular/router';
import {Profile} from '../domain/authentication/profile';
import {CustomerDetail} from '../domain/customer/customer-detail';
import {StorageItem} from '../enums/storage-item';
import {AccountService} from './account.service';
import {CustomerDetailService} from './customer-detail.service';
import {NotificationsService} from './notifications.service';
import {CustomerProfileService} from './customer-profile.service';
import {FamilyHealthService} from './family-health.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient,
              private localStorage: LocalStorageService,
              private router: Router,
              private accountService: AccountService,
              private notificationsService: NotificationsService,
              private customerDetailService: CustomerDetailService,
              private customerProfileService: CustomerProfileService,
              private familyHealthService: FamilyHealthService) {
  }

  login(email: string, password: string) {
    return this.http.post('/onboarding/authorizations', {email, password}).pipe(
      map(
        (response: any) => {
          const profile: Profile = {
            customerDetail: new CustomerDetail(), // FIXME ELIMINAR DEL LOCAL STORAGE
            roles: response.roles,
            authorities: response.authorities,
            accessToken: response.access_token,
            refreshToken: response.refresh_token,
            duration: response.expires_in,
            tokenDate: new Date(),
            locale: response.locale
          };
          this.localStorage.set(StorageItem.PROFILE, profile);
          return;
        }
      )
    );
  }

  refreshToken() {
    const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
    return this.http.post(
      `/onboarding/authorizations/accesstoken`, {
        grant_type: 'refresh_token',
        refresh_token: profile.refreshToken
      }).pipe(
      catchError(error => {
        this.logout();
        return of(error);
      })
    );
  }

  passwordRecovery(email: string, reCaptchaToken: any) {
    return this.http.post('/onboarding/user/recover', {
      email,
      reCaptchaToken
    });
  }

  logout() {
    // TODO revisar ocn jab, creo que si hay un método de logout en el backend
    // Agregar aquellas claves que tengan que ser eliminadas del localStorage.
    this.localStorage.remove(StorageItem.CONFIGS_HOME);
    this.localStorage.remove(StorageItem.CONFIGS_ACCOUNT);
    this.localStorage.remove(StorageItem.CONFIGS_APPLICATION);
    this.localStorage.remove(StorageItem.PROFILE);
    this.notificationsService.msgs = [];
    this.customerDetailService.logOut();
    this.customerProfileService.logOut();
    this.familyHealthService.logout();
    this.router.navigate(['/login']);
  }

  setLocale(locale: string) {
    let profile: any = this.localStorage.get(StorageItem.PROFILE);
    if (profile != null) {
      profile.locale = locale;
    } else {
      profile = {
        locale
      };
    }
    this.localStorage.set(StorageItem.PROFILE, profile);
  }

  setLanguage(language: string) {
    return this.http.put(`/onboarding/user/language`, {
      languageCode: language
    });
  }

  isAuthenticated(): boolean {
    const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
    return profile != null && profile.accessToken != null;
  }
  // Reset Password, you have to change the path
  passwordReset(password: string, passwordConfirmation: string, passwordRecoveryToken: string) {
    return this.http.put('/onboarding/user/reset', { // Change path
      password,
      matchingPassword: passwordConfirmation,
      recoveryToken: passwordRecoveryToken
    });
  }
  // Email Confirmation, you must change the path
  emailConfirmation(token: string) {
    return this.http.put(`/onboarding/user/confirmation/${token}`, {});
  }
  // TODO Esto actualmente ocurre en el autorizador, quizá debería pasarse para acá
  // passwordReset(password: string, passwordConfirmation: string, passwordRecoveryToken: string) {
  //   return this.http.put('/api/users/reset', {
  //     password: password,
  //     passwordConfirmation: passwordConfirmation,
  //     passwordRecoveryToken: passwordRecoveryToken
  //   });
  // }

}
